import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';


@Injectable({
    providedIn: 'root'
})
export class hasDIADEMAccessGuard  {
    constructor(protected router: Router, protected s_auth: AuthService) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.s_auth.isClient()) {
            return true;
        } else {
            this.router.navigate(["error", 403], {
                queryParams: { message: 'ERROR.ONLYDIADEMCAN' },
            });
            return false;
        }
    }
}